// extracted by mini-css-extract-plugin
export default {"inputs":"BirthDate_inputs__nsPIp","button":"BirthDate_button__Tgl0V"};